/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Directive, HostListener } from '@angular/core';
import { ValidationService } from '../../services';

@Directive({
    selector: 'input[appNumbersOnly]'
})

export class NumberOnlyDirective {
    @HostListener('keydown', ['$event'])
    public onKeyDown(event: KeyboardEvent): void {
        const navigationKeys = [
            'ArrowDown',
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'Backspace',
            'Clear',
            'Copy',
            'Delete',
            'End',
            'Enter',
            'Escape',
            'Home',
            'Paste',
            'Tab'
        ];

        if (/[^0-9]+/g.test(event.key) && !navigationKeys.includes(event.key) && !ValidationService.actionKeyCombinations(event)) {
            event.preventDefault();
        }
    }

    @HostListener('keyup', ['$event'])
    public onKeyPress(event: KeyboardEvent): void {
        // This removes any whitespace and full-stops that can be entered by double-tapping spacebar.
        const input = event.target as HTMLInputElement;
        input.value = input.value.replace(/[\W_]/g, '');
    }

    @HostListener('paste', ['$event'])
    public onPaste($event: ClipboardEvent): void {
        const pastedData: string = $event.clipboardData.getData('Text');
        const regex: RegExp = new RegExp(/^\d+$/);
        const matches: RegExpMatchArray = pastedData.match(regex);
        if (!matches) {
            $event.preventDefault();
        }
    }
}
